export const COHORT_MODULE_OPTIONS = [
	{ value: "profile", label: "Profile" },
	{ value: "deposit", label: "Deposit" },
	{ value: "withdrawal", label: "Withdrawal" },
	{ value: "registration", label: "Registration" },
];

export const WELCOME_REGISTRATION_COHORT_FIELDS = [
	"id",
	"email",
	"phone",
	"country",
	"bot_id",
	"referer",
	"registration_from",
	"registration_to",
	"registration_date",
];

export const COHORT_LOGICAL_OPERATOR_OPTIONS = [
	{ value: "AND", label: "AND" },
	{ value: "OR", label: "OR" },
];

export const COHORT_OPERATOR_OPTIONS = [
	{ value: "=", label: "=" },
	{ value: "!=", label: "!=" },
	{ value: ">", label: ">" },
	{ value: ">=", label: ">=" },
	{ value: "<", label: "<" },
	{ value: "<=", label: "<=" },
	{ value: "IN", label: "IN" },
	{ value: "NOT IN", label: "NOT IN" },
	{ value: "BETWEEN", label: "BETWEEN" },
];

const DEFAULT_COHORT_OPERATORS = ["=", ">", "<", ">=", "<=", "IN"];

export const BOOLEAN_OPTIONS = [
	{ value: "1", label: "Required" },
	{ value: "0", label: "No" },
];

export const CRYPTO_OR_FIAT_OPTIONS = [
	{ value: "crypto", label: "Crypto" },
	{ value: "fiat", label: "Fiat" },
];

export const PARTNER_PAYMENT_TYPE_OPTIONS = [
	{ value: "RS", label: "RS" },
	{ value: "CPA", label: "CPA" },
	{ value: "RevShare", label: "RevShare" },
	{ value: "Fix", label: "Fix" },
];

export const createCohortId = () => {
	if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
		return crypto.randomUUID();
	}

	return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const getGroupKeyByModule = (module) => {
	if (module === "deposit") return "depositFilters";
	if (module === "withdrawal") return "withdrawalFilters";
	if (module === "registration") return "registrationFilters";

	return "profileFilters";
};

export const getModuleByField = (field) => {
	if ((field || "").startsWith("deposit_")) return "deposit";
	if ((field || "").startsWith("withdrawal_")) return "withdrawal";
	if ((field || "").startsWith("registration_")) return "registration";

	return "profile";
};

export const getCohortFieldOptions = () => [
	{ value: "id", label: "Id", type: "string" },
	{ value: "risk_model", label: "Risk model", type: "multiselect", specialType: "riskModel" },
	{ value: "verify", label: "Verify", type: "select", specialType: "boolean" },
	{ value: "email", label: "Email", type: "select", specialType: "boolean" },
	{ value: "phone", label: "Phone", type: "select", specialType: "boolean" },
	{ value: "tg", label: "Telegram", type: "select", specialType: "boolean" },
	{ value: "lang", label: "Language", type: "string", section: "profile", operators: ["=", "!=", "IN", "NOT IN"] },
	{ value: "country", label: "Country", type: "string", section: "profile", operators: ["=", "IN"] },
	{ value: "date_last_login", label: "Last login date", type: "date", section: "profile", operators: ["=", "!=", ">", ">=", "<", "<=", "BETWEEN"] },
	{ value: "bot_id", label: "Telegram bot ID", type: "string", section: "profile", operators: ["=", "!=", "IN", "NOT IN"] },
	{ value: "partnerName", label: "Partner Name", type: "string" },
	{ value: "paymentType", label: "Payment Type", type: "select", specialType: "partnerPaymentType" },
	{ value: "trafficType", label: "Traffic Type", type: "string" },
	{ value: "tasks_count", label: "Tasks count", type: "count" },
	{ value: "tasks_days", label: "Tasks days", type: "count" },
	{ value: "sweepstakes_count", label: "Sweepstakes count", type: "count" },
	{ value: "spins", label: "Spins", type: "count" },
	{ value: "lvl_club", label: "Club", type: "count" },
	{ value: "referer", label: "Referer", type: "count" },
	{ value: "balance", label: "Balance", type: "count" },

	{ value: "deposit_date", label: "Deposit date", type: "count" },
	{ value: "deposit_date_crypto", label: "Deposit crypto date", type: "count" },
	{ value: "deposit_date_fiat", label: "Deposit fiat date", type: "count" },
	{ value: "deposit_count", label: "Deposit count", type: "count" },
	{ value: "deposit_count_fiat", label: "Deposit fiat count", type: "count" },
	{ value: "deposit_count_crypto", label: "Deposit crypto count", type: "count" },
	{ value: "deposit_from", label: "Deposit from", type: "date" },
	{ value: "deposit_to", label: "Deposit to", type: "date" },
	{ value: "deposit_crypto_from", label: "Deposit crypto from", type: "date" },
	{ value: "deposit_crypto_to", label: "Deposit crypto to", type: "date" },
	{ value: "deposit_fiat_from", label: "Deposit fiat from", type: "date" },
	{ value: "deposit_fiat_to", label: "Deposit fiat to", type: "date" },
	{ value: "deposit_amount_to", label: "Deposit amount to", type: "count" },
	{ value: "deposit_amount_from", label: "Deposit amount from", type: "count" },
	{ value: "deposit_amount_crypto_to", label: "Deposit amount crypto to", type: "count" },
	{ value: "deposit_amount_crypto_from", label: "Deposit amount crypto from", type: "count" },
	{ value: "deposit_amount_fiat_to", label: "Deposit amount fiat to", type: "count" },
	{ value: "deposit_amount_fiat_from", label: "Deposit amount fiat from", type: "count" },
	{ value: "deposit_type", label: "Deposit type", type: "select", specialType: "cryptoOrFiat" },

	{ value: "withdrawal_date", label: "Withdrawal date", type: "count" },
	{ value: "withdrawal_date_crypto", label: "Withdrawal crypto date", type: "count" },
	{ value: "withdrawal_date_fiat", label: "Withdrawal fiat date", type: "count" },
	{ value: "withdrawal_count", label: "Withdrawal count", type: "count" },
	{ value: "withdrawal_count_fiat", label: "Withdrawal fiat count", type: "count" },
	{ value: "withdrawal_count_crypto", label: "Withdrawal crypto count", type: "count" },
	{ value: "withdrawal_from", label: "Withdrawal from", type: "date" },
	{ value: "withdrawal_to", label: "Withdrawal to", type: "date" },
	{ value: "withdrawal_crypto_from", label: "Withdrawal crypto from", type: "date" },
	{ value: "withdrawal_crypto_to", label: "Withdrawal crypto to", type: "date" },
	{ value: "withdrawal_fiat_from", label: "Withdrawal fiat from", type: "date" },
	{ value: "withdrawal_fiat_to", label: "Withdrawal fiat to", type: "date" },
	{ value: "withdrawal_amount_to", label: "Withdrawal amount to", type: "count" },
	{ value: "withdrawal_amount_from", label: "Withdrawal amount from", type: "count" },
	{ value: "withdrawal_amount_crypto_to", label: "Withdrawal amount crypto to", type: "count" },
	{ value: "withdrawal_amount_crypto_from", label: "Withdrawal amount crypto from", type: "count" },
	{ value: "withdrawal_amount_fiat_to", label: "Withdrawal amount fiat to", type: "count" },
	{ value: "withdrawal_amount_fiat_from", label: "Withdrawal amount fiat from", type: "count" },
	{ value: "withdrawal_type", label: "Withdrawal type", type: "select", specialType: "cryptoOrFiat" },

	{ value: "registration_from", label: "Registration from", type: "date" },
	{ value: "registration_to", label: "Registration to", type: "date" },
	{ value: "registration_date", label: "Registration user days", type: "count" },
];

export const getCohortFieldOptionsByModule = (module) => {
	const fields = getCohortFieldOptions();

	if (module === "deposit") return fields.filter((field) => field.value.startsWith("deposit_"));
	if (module === "withdrawal") return fields.filter((field) => field.value.startsWith("withdrawal_"));
	if (module === "registration") return fields.filter((field) => field.value.startsWith("registration_"));

	return fields.filter(
		(field) =>
			!field.value.startsWith("deposit_") &&
			!field.value.startsWith("withdrawal_") &&
			!field.value.startsWith("registration_")
	);
};

export const getCohortOperatorOptions = (field) => {
	const fieldOption = typeof field === "string" ? getCohortFieldOptions().find((option) => option.value === field) : field;
	const operators = fieldOption?.operators || DEFAULT_COHORT_OPERATORS;

	return operators.map((operator) => COHORT_OPERATOR_OPTIONS.find((option) => option.value === operator)).filter(Boolean);
};

export const parseCohortConditions = (value) => {
	if (Array.isArray(value)) return value;
	if (!value) return [];

	if (typeof value === "string") {
		try {
			const parsed = JSON.parse(value);
			return Array.isArray(parsed) ? parsed : [];
		} catch (error) {
			return [];
		}
	}

	return [];
};

export const createDefaultCohortGroup = () => ({
	groupId: createCohortId(),
	module: "deposit",
	groupKey: "depositFilters",
	groupLogicalOperator: null,
});

export const normalizeCohortConditions = (rawConditions) => {
	const parsedConditions = parseCohortConditions(rawConditions);

	if (!parsedConditions.length) {
		return {
			groups: [createDefaultCohortGroup()],
			conditions: [],
		};
	}

	const groupMap = new Map();
	const conditions = parsedConditions.map((condition, index) => {
		const module = condition.module || getModuleByField(condition.field);
		const groupId = condition.groupId || `${module}-${condition.groupOrder ?? 0}`;
		const groupOrder = Number.isFinite(Number(condition.groupOrder)) ? Number(condition.groupOrder) : groupMap.size;

		if (!groupMap.has(groupId)) {
			groupMap.set(groupId, {
				groupId,
				module,
				groupKey: condition.groupKey || getGroupKeyByModule(module),
				groupOrder,
				groupLogicalOperator: groupOrder === 0 ? null : condition.groupLogicalOperator || "AND",
			});
		}

		return {
			id: condition.id || createCohortId(),
			field: condition.field,
			fieldLabel: condition.fieldLabel || condition.field,
			section: condition.section || (["lang", "date_last_login", "bot_id"].includes(condition.field) ? "profile" : undefined),
			operator: condition.operator || "=",
			value: condition.value,
			conditionalType: condition.conditionalType || "string",
			specialType: condition.specialType,
			logicalOperator: condition.logicalOperator || null,
			conditionOrder: Number.isFinite(Number(condition.conditionOrder)) ? Number(condition.conditionOrder) : index,
			groupId,
			module,
			groupKey: condition.groupKey || getGroupKeyByModule(module),
			groupOrder,
			groupLogicalOperator: groupOrder === 0 ? null : condition.groupLogicalOperator || "AND",
		};
	});

	const groups = Array.from(groupMap.values())
		.sort((a, b) => (a.groupOrder ?? 0) - (b.groupOrder ?? 0))
		.map((group, index) => ({
			groupId: group.groupId,
			module: group.module,
			groupKey: group.groupKey || getGroupKeyByModule(group.module),
			groupLogicalOperator: index === 0 ? null : group.groupLogicalOperator || "AND",
		}));

	return {
		groups: groups.length ? groups : [createDefaultCohortGroup()],
		conditions: normalizeConditionsForSave(conditions, groups),
	};
};

export const normalizeConditionsForSave = (conditions, groups) => {
	const nextGroups = groups && groups.length ? groups : [createDefaultCohortGroup()];
	const groupIndexById = new Map(nextGroups.map((group, index) => [group.groupId, index]));

	return (conditions || [])
		.filter((condition) => condition.field)
		.sort((a, b) => {
			const groupOrderA = groupIndexById.get(a.groupId) ?? 0;
			const groupOrderB = groupIndexById.get(b.groupId) ?? 0;
			if (groupOrderA !== groupOrderB) return groupOrderA - groupOrderB;
			return (a.conditionOrder ?? 0) - (b.conditionOrder ?? 0);
		})
		.map((condition, index, sortedConditions) => {
			const group = nextGroups.find((item) => item.groupId === condition.groupId) || nextGroups[0];
			const groupOrder = groupIndexById.get(group.groupId) ?? 0;
			const previousCondition = sortedConditions[index - 1];
			const isFirstInGroup = !previousCondition || previousCondition.groupId !== condition.groupId;

			return {
				...condition,
				id: condition.id || createCohortId(),
				module: group.module,
				groupKey: group.groupKey || getGroupKeyByModule(group.module),
				groupOrder,
				groupLogicalOperator: groupOrder === 0 ? null : group.groupLogicalOperator || "AND",
				conditionOrder: sortedConditions.filter((item) => item.groupId === condition.groupId).findIndex((item) => item.id === condition.id),
				logicalOperator: isFirstInGroup ? null : condition.logicalOperator || "AND",
			};
		});
};

export const isConditionValueEmpty = (value) =>
	value === null ||
	value === "" ||
	typeof value === "undefined" ||
	(Array.isArray(value) && (value.length === 0 || value.some((item) => item === null || item === "" || typeof item === "undefined")));

const parsePositiveUid = (value) => {
	const normalized = String(value ?? "").trim();
	if (!/^\d+$/.test(normalized)) return null;

	const uid = Number(normalized);
	return Number.isSafeInteger(uid) && uid > 0 ? uid : null;
};

export const hasValidItemUidCondition = (conditions = []) =>
	conditions.some((condition) => {
		if (!condition || String(condition.field || "") !== "id") return false;

		const operator = String(condition.operator || "").toUpperCase();
		if (operator !== "=" && operator !== "IN") return false;

		const rawValues = Array.isArray(condition.value)
			? condition.value
			: operator === "IN"
				? String(condition.value ?? "").split(",")
				: [condition.value];

		const validValues = rawValues
			.map((value) => parsePositiveUid(value))
			.filter((value) => value !== null);

		if (operator === "=") {
			return rawValues.length === 1 && validValues.length === 1;
		}

		return rawValues.length > 0 && validValues.length === rawValues.length;
	});

export const formatConditionValue = (value) => {
	if (Array.isArray(value)) return value.join(", ");
	if (value && typeof value === "object" && Object.prototype.hasOwnProperty.call(value, "label")) return value.label;

	return value || "-";
};
